import React from 'react';

const CautionIcon: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5 8V14M21.5 20.5H1.5L11.5 2.5L21.5 20.5ZM11.5 16V18V16Z" stroke="#EB0D3F" />
    </svg>
  );
};

export default CautionIcon;
